mutation UndeleteManagedMeetingTemplate($input: MeetingUndeleteInput!) {
    meetingUndelete(input: $input) {
        meeting {
            id
            deletedTime
        }
    }
}
